import React from 'react';
import { Spinner } from 'reactstrap';

interface ICenterSpinnerProps {
  showLoader: boolean;
  className?: string;
}

const CenterSpinner: React.FunctionComponent<ICenterSpinnerProps> = ({
  className,
  showLoader,
}) => {
  return (
    <>
      {showLoader && (
        <div className={`spinner-element ${className ?? 'spinner-center'}`}>
          <Spinner>Loading...</Spinner>
        </div>
      )}
      {!showLoader && <div></div>}
    </>
  );
};

export default CenterSpinner;
